import type {
  AnalyticsActivity,
  AnalyticsActivityValues,
} from '@carboncopyco/data';
import type { Resolution, TimePeriod } from '@carboncopyco/types';
import type { DropdownFilterItemContent } from '@carboncopyco/ui';
import dayjs from 'dayjs';
import type { LineChartData } from './types';

export const getDateFromToInFormat = (currentDate: string) => {
  const start = dayjs(currentDate);
  const end = start.add(6, 'day');
  if (start.year() !== end.year()) {
    return `${start.format('MMM D, YYYY')} - ${end.format('MMM D, YYYY')}.`;
  }
  if (start.month() !== end.month()) {
    return `${start.format('MMM D')} - ${end.format('MMM D, YYYY')}.`;
  }
  return `${start.format('MMM D')}-${end.format('D, YYYY')}.`;
};

export const getResolutionOptions = (
  timePeriod: TimePeriod
): DropdownFilterItemContent<Resolution>[] => [
  {
    id: 'day',
    label: 'Days',
    disabled: false,
  },
  {
    id: 'week',
    label: 'Weeks',
    disabled: timePeriod === '7',
  },
  {
    id: 'month',
    label: 'Months',
    disabled: timePeriod === '7',
  },
];

export const mapChartData = (
  data: AnalyticsActivity[],
  key: keyof AnalyticsActivityValues
) => data?.map((item: AnalyticsActivity) => item?.values[key]) ?? [];

export function calculatePercentageDifference(
  current: number,
  prev: number
): number {
  const difference = current - prev;
  const percentageDifference = (difference / prev) * 100;
  return Number(percentageDifference.toFixed(0));
}

export function extractDataForChart(
  data?: Array<AnalyticsActivity>
): LineChartData {
  if (!data) {
    return { values: [], timestamps: [] };
  }
  const values = data.map((item: AnalyticsActivity) =>
    Math.round(item.values.occurrences)
  );
  const timestamps = data.map((item: AnalyticsActivity) => item.timestamp);

  return { values, timestamps };
}
